const DISPLAY_FIELDS = [
  ['utm_source', 'Origem (utm_source)'],
  ['utm_medium', 'Mídia (utm_medium)'],
  ['utm_campaign', 'Campanha (utm_campaign)'],
  ['utm_content', 'Conteúdo (utm_content)'],
  ['utm_term', 'Palavra-chave (utm_term)'],
  ['utm_id', 'ID da campanha (utm_id)'],
  ['gclid', 'Google Click ID (gclid)'],
  ['gbraid', 'Google GBRAID'],
  ['wbraid', 'Google WBRAID'],
  ['fbclid', 'Meta Click ID (fbclid)'],
  ['referrer_host', 'Domínio de referência'],
]

export function trackingMethod(attribution) {
  if (!attribution) return 'Não rastreado'
  if (attribution.tracking_click_id || attribution.tracking_link) return 'Link rastreável'
  return 'Parâmetros de campanha'
}

export function trackingParameters(attribution) {
  const values = new Map()
  if (attribution?.landing_url) {
    try {
      new URL(attribution.landing_url).searchParams.forEach((value, key) => values.set(key, value))
    } catch { /* URL antiga ou incompleta */ }
  }
  DISPLAY_FIELDS.forEach(([key, label]) => {
    if (attribution?.[key]) values.set(key, attribution[key])
    if (values.has(key)) values.set(key, { label, value: values.get(key) })
  })
  return [...values.entries()].map(([key, entry]) => ({
    key,
    label: entry?.label || key,
    value: entry?.value ?? entry,
  }))
}
